import { type RecruitmentEvaluationResponsePagedData } from '@on3/api';
import { Pagination } from '@on3/ui-lib/components/Pagination/Pagination';
import { BreadCrumb } from 'components/BreadCrumb/BreadCrumb';
import { CompactPlayer } from 'components/Db/Profile/Header/CompactHeaderV2/CompactPlayerV2';
import { ScoutingJournalItem } from 'components/Db/Profile/ScoutingJournal/ScoutingJournalItem';
import useAthlete from 'contexts/AthleteProvider';

import styles from './ScoutingJournalPage.module.scss';

interface ScoutingJournalPageProps {
  scoutingJournals?: RecruitmentEvaluationResponsePagedData | null;
}

export const ScoutingJournalPage = ({
  scoutingJournals,
}: ScoutingJournalPageProps) => {
  const { athlete } = useAthlete();
  const { list, pagination } = scoutingJournals || {};

  return (
    <div className={styles.block}>
      <CompactPlayer className={styles.compactPlayer} />
      <BreadCrumb
        className={styles.breadcrumbs}
        crumbs={[
          { title: 'Rivals', href: '/rivals/' },
          { title: `${athlete?.name}`, href: `/rivals/${athlete?.slug}/` },
        ]}
        title="Scouting Journals"
      />
      <section className={styles.scoutingJournals}>
        <h1>{`Scouting Journals for ${athlete?.name}`}</h1>
        <section className={styles.list}>
          {list?.length ? (
            <>
              {list.map((journal) => (
                <ScoutingJournalItem {...journal} key={journal.key} />
              ))}
            </>
          ) : (
            <p className={styles.none}>No scouting journals found.</p>
          )}
        </section>
        {pagination?.count && pagination?.count > 25 && (
          <Pagination data={pagination} type="simple" />
        )}
      </section>
    </div>
  );
};
